"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'LoadMessageContent',
  props: {
    message: {
      type: String,
      default: ''
    },
    load: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isFullPage: false
    };
  }
};